import React, { useEffect, useState } from "react";
import axios from "../api/baseurl";
import "react-toastify/dist/ReactToastify.css";
import { toast } from "react-toastify";
import { useNavigate } from "react-router";
import { BiEditAlt } from "react-icons/bi";
import UpdateAdminLink from "./updateAdminLink";
import MapCompanyAndLabs from "./companyAndLabsMapping";
import { MdDeleteForever } from "react-icons/md";
import { faSearch } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Pagination } from "react-bootstrap";

function LinkedLabs({selectedOrgcode}) {
  const [linkedlabs, setLinkedLabs] = useState([]);
  const [loader, setLoader] = useState(true);
  const [isMapCompanyAndLabs, setIsMapCompanyAndLabs] = useState(false);
  const [selectedCompanyId, setSelectedCompanyId] = useState(null);
  const [searchTerm, setSearchTerm] = useState("");
   const [currentPage, setCurrentPage] = useState(0);
   const [totalPages, setTotalPages] = useState(0);

  const token = JSON.parse(localStorage.getItem("data")).token;
  
  
  useEffect(() => {
    if (searchTerm.trim()) {
      searchData(0);  
    } else {
      getData(currentPage);   
  }
  }, [searchTerm]); 
  
    const searchData = async (pageNumber = 0) => {
      setLoader(true);
      try {
       const searchUrl = `/api/company-labs-mapping/searchLinkedLabs`;
                const requestData = {
                  searchTerm
                };
          
        const response = await axios.post(searchUrl, requestData, {
          params: { companyId:selectedCompanyId,page: pageNumber },
          headers: { Authorization: `Bearer ${token}` },
        });
        setLinkedLabs(response.data.content);
        setCurrentPage(response.data.number);
        setTotalPages(response.data.totalPages);
        setLoader(false);
      } catch (error) {
        setLoader(false);
        handleError(error);
      }
    };
  
    const getData = async (pageNumber = 0) => {
    setLoader(true);
    try {
      const compResponse = await axios.get(`/api/companydetails/companycode=${selectedOrgcode}`, {
        headers: { Authorization: `Bearer ${token}` },
      });
      setSelectedCompanyId(compResponse.data.id);

      const response = await axios.get(`/api/company-labs-mapping/getLinkedLabsByCompanyId/companyId=${compResponse.data.id}`, {
        params: { page: pageNumber },
        headers: { Authorization: `Bearer ${token}` },
      });

      setLinkedLabs(response.data.content);
      setCurrentPage(response.data.number);
      setTotalPages(response.data.totalPages);
      setLoader(false);
    } catch (error) {
      setLoader(false);
      handleError(error);
    }
  };

  const navigate = useNavigate();
  function handleError(error) {
    if (error.response) {
      if (error.response.status === 401) {
        navigate(`/signin`);
        toast.error("Your session has expired. Please login.");
      } else if (error.response.data && error.response.data.message) {
        toast.error(error.response.data.message);
      }  else if (error.response.data && error.response.data.code) {
        toast.error(error.response.data.code);
      }
       else {
        toast.error("An error occurred.");
      }
    } else if (error.message) {
      toast.error(error.message);
    } else {
      toast.error("An error occurred.");
    }
  }

  const handleOpenMapPopup = () => {
    setIsMapCompanyAndLabs(true);
  };

  const handleCloseMapPopup = () => {
    setSelectedCompanyId(null);
    setIsMapCompanyAndLabs(false);
    getData();
  };

  const handleDeleteLabMapping = async (id) => {
    const token = JSON.parse(localStorage.getItem("data")).token;
    if (window.confirm("Are you sure you want to delete this mapping?")) {
    try {
      // Using axios.request to send DELETE with data in body
      await axios.request({
        url: `/api/company-labs-mapping`,
        method: 'DELETE',
        headers: { Authorization: `Bearer ${token}` },
        data: { id: id }, // Passing id in the body
      });
  
      toast.success("Lab mapping removed successfully");
     getData();
    } catch (error) {
      handleError(error);
    }
}
  };

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  
    if (searchTerm.trim()) {
      searchData(newPage);
    } else {
      getData(newPage);
    }
  };
  const renderPageNumbers = () => {
    const pageNumbers = [];
    const maxPageNumbersToShow = 5;
    let startPage = Math.max(0, currentPage - 2);
    let endPage = Math.min(totalPages - 1, currentPage + 2);

    if (currentPage <= 2) {
      endPage = Math.min(totalPages - 1, maxPageNumbersToShow - 1);
    }

    if (currentPage >= totalPages - 3) {
      startPage = Math.max(0, totalPages - maxPageNumbersToShow);
    }

    for (let i = startPage; i <= endPage; i++) {
      pageNumbers.push(
        <Pagination.Item key={i} active={i === currentPage} onClick={() => handlePageChange(i)}>
          {i + 1}
        </Pagination.Item>
      );
    }
    return pageNumbers;
  };

  return (
    <div>
      <div className="company-profile">
        <div className="card card-raised mb-5">
          <div className="card-body">
            <div className="card-title form-group d-flex align-items-center justify-content-between">
            <span>Labs</span>
            <div className="form-group position-relative" style={{ width: '300px' }}> {/* Adjust width as needed */}
  <input
    type="search"
    className="form-control pl-4"
    placeholder="Search by Lab name or Lab code"
    value={searchTerm}
    onChange={(e) => setSearchTerm(e.target.value)}
    style={{ paddingLeft: "2rem", width: "100%" }} // Ensure the input takes the full width of the parent div
  />
  <span className="position-absolute" style={{ left: "10px", top: "50%", transform: "translateY(-50%)" }}>
    <FontAwesomeIcon icon={faSearch} />
  </span>
  </div>
     
  <button className="btn btn-primary" onClick={handleOpenMapPopup}>
    LINK LABS
  </button>

            </div>
            <br />
            <table className="table table-bordered">
                <thead>
                  <tr className="table-header">
                  <th>Lab name</th>
                  <th>Lab Code</th>
                  <th>Address</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {linkedlabs.length===0 ? (
                  <tr>
                    <td colSpan="10" className="text-center">
                      No Data Available
                    </td>
                  </tr>
                ) : (
                    linkedlabs.map((lab, index) => (
                
                    <tr key={lab.id}>

                      <td>{lab.labs?.labname}</td>
                     <td>{lab.labs?.labcode}</td>
                        <td>{lab.labs?.addressLine1}
                        {lab.labs?.addressLine2 && `, ${lab.labs.addressLine2}`}
                        </td>
                        <td  style={{ cursor: 'pointer' }}>
                        <MdDeleteForever
            style={{ cursor: "pointer", fontSize:"20px"}} title="Remove Mapped lab"
            onClick={() => handleDeleteLabMapping(lab.id)}
          />
                        </td>
                    </tr>
                    ))
                )}
              
              </tbody>
            </table>
            <div className="d-flex justify-content-center">
              <Pagination>
                <Pagination.First onClick={() => handlePageChange(0)} disabled={currentPage === 0} />
                <Pagination.Prev onClick={() => handlePageChange(currentPage - 1)} disabled={currentPage === 0} />
                {renderPageNumbers()}
                <Pagination.Next onClick={() => handlePageChange(currentPage + 1)} disabled={currentPage === totalPages - 1} />
                <Pagination.Last onClick={() => handlePageChange(totalPages - 1)} disabled={currentPage === totalPages - 1} />
              </Pagination>
            </div>
            {isMapCompanyAndLabs && (
              <MapCompanyAndLabs isOpen={isMapCompanyAndLabs} onRequestClose={handleCloseMapPopup} companyId={selectedCompanyId} />
            )}
          </div>
        </div>
      </div>
      {loader && <div className="loading"></div>}
    </div>
  );
}

export default LinkedLabs;
